exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-bom-popup-container {\r\n    background-color: #F0F0F0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/common/view-bom-popup/view-bom-popup.component.css
// module id = ../../../../../src/app/shared/components/common/view-bom-popup/view-bom-popup.component.css
// module chunks = main